export default "/bitrix/js/ui/sign-up/dist/images/touch-active.svg"